<template>
  <div class="city-path-container">
    <div class="path path1"></div>
    <div class="path path2"></div>
  </div>
</template>

<script>
export default {
  name: 'CityPath',
  props: {
    msg: String
  },
  mounted () {
  }
}

</script>
<style scoped lang="scss">
.city-path-container {
  width: 100%;
  height: 100%;
  position: absolute;
  pointer-events: none;
  .path {
    display: block;
    position: absolute;
    overflow: hidden;
    &.path1 {
      width: 335px;
      height: 100px;
      // border: 1px solid red;
      left: 510px;
      top: 350px;
      &::after {
        content: "";
        display: block;
        position: absolute;
        width: 2000px;
        height: 2000px;
        border: 2px dashed #F8F8C2;
        border-radius: 50%;
        top: 1px;
        left: -764px;
        animation: line-move 300s linear infinite running;
      }
    }
    &.path2 {
      width: 298px;
      height: 100px;
      left: 548px;
      top: 360px;
      &::after {
        content: "";
        display: block;
        position: absolute;
        width: 2000px;
        height: 2000px;
        border: 2px dashed #F8F8C2;
        border-radius: 50%;
        top: 1px;
        left: -710px;
        animation: line-move 300s linear infinite running; }
    }
  }
}
@keyframes line-move {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(-360deg);
  }
}
</style>
